import { createContext } from 'react';
import type { LoomSDKContextValueType } from '../types';

const initContextValue: LoomSDKContextValueType = {
	sdk: null,
	initializing: true,
	supported: false,
};

// Create a context for the Loom SDK
export const LoomSDKContext = createContext<LoomSDKContextValueType>(initContextValue);
